module.exports = __webpack_public_path__ + "media/images/zoom_out_glass_icon-a4efced9.png";